// RegistrationPrompt.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import { Typography, Box } from "@mui/material";

const RegistrationPrompt = ({ navigate }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ marginTop: "40px", gap: "20px", display: "flex", flexDirection: "column", alignItems: "center" }}>
      <Typography sx={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "16px", lineHeight: "100%" }}>
        {t("Don't have an account?")}
        <span
          onClick={() => navigate("/register")}
          style={{ color: "#20A8E0", cursor: "pointer", marginLeft: "5px" }}
        >
          {t("Register Now")}
        </span>
      </Typography>
      <span style={{ fontFamily: "Roboto", fontWeight: 400, fontSize: "16px", cursor: "pointer", border:"none"}}>
        <a 
          href="https://routeeye.io/support/" 
          target="_blank" 
          rel="noopener noreferrer"
          style={{ color: "#20A8E0", textDecoration: "none" }}
        >
          {t("Need Help?")}
        </a>
      </span>
   </Box>
 );
};

export default RegistrationPrompt;